import React from 'react'
import { Main } from './components'

const IntegratedMessaging = () => <Main />

export default IntegratedMessaging
